<section class="flex justify-center bg-G50">
  <div
    class="max-w-[1440px] w-full py-[56px] px-[16px] md:py-[112px] md:px-[64px]"
  >
    <div class="flex flex-col gap-4 md:gap-[64px]">
      <div
        class="flex flex-col md:flex-row md:justify-between gap-2 md:gap-[100px]"
      >
        <div class="md:max-w-[410px] grid gap-2">
          <div class="text-b2 text-G500">
            {{ browseFreelancersSection.subTitle }}
          </div>
          <div
            class="text-h4 md:text-h3 text-G800 leading-[1.2] font-medium md:max-w-[410px]"
          >
            {{ browseFreelancersSection.title }}
          </div>
        </div>
        <div class="md:max-w-[430px] grid gap-8 md:gap-4">
          <div class="text-b1 text-G700">
            {{ browseFreelancersSection.description }}
          </div>
          <div [routerLink]="['/search']" class="w-max">
            <basic-button
              [type]="1"
              [title]="browseFreelancersSection.buttonText1"
            />
          </div>
        </div>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
        <div
          *ngFor="let card of providerTypeArray"
          (click)="clickProviderTypeTag(card.title)"
          class="h-full bg-white hover:bg-G100 active:bg-G200 border border-G200 grid p-[24px] md:p-[40px] transition-all duration-200 cursor-pointer rounded-[12px] select-none grid-rows-subgrid row-span-3 gap-y-[16px]"
        >
          <img src="{{ card.iconSrc }}" class="w-[48px] h-[48px]" />
          <div class="text-G900 text-h6 md:text-h5 font-medium">
            {{ card.title }}
          </div>
          <div class="text-G500 text-b2 md:text-b1">{{ card.description }}</div>
        </div>
      </div>
      <!-- <div class="overflow-x-scroll">
        <div class="min-w-[1200px] flex justify-between">
          <div
            *ngFor="let section of browseFreelancersSection.sections"
            class="grid gap-2"
          >
            <div
              *ngFor="let category of section"
              class="w-max text-b1 text-G700 hover:underline underline-offset-2 cursor-pointer"
            >
              {{ category }}
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</section>
